import { Link } from 'react-router-dom';
import { Star, Heart } from 'lucide-react';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import TargetAudienceSection from './components/TargetAudienceSection';
import ReviewsSection from './components/ReviewsSection';
import ContactSection from './components/ContactSection';

function Home() {
  return (
    <>
      <Hero />
      <FeaturesSection />
      <TargetAudienceSection />
      <ReviewsSection />
      <ContactSection />
      
      {/* Footer */}
      <footer className="bg-gradient-to-br from-primary-800 via-accent-900 to-violet-900 text-white py-12 relative overflow-hidden">
        {/* Background pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-64 h-64 bg-gradient-to-br from-accent-400 to-violet-400 rounded-full blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-80 h-80 bg-gradient-to-tl from-primary-400 to-secondary-400 rounded-full blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-6 text-center relative z-10">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="relative">
            <div className="absolute -inset-1 bg-gradient-to-r from-secondary-400 to-primary-400 rounded-lg blur opacity-50"></div>
              <img
                src="/wezen-logo.png"
                alt="WeZen Logo"
                className="w-12 h-12 rounded-lg object-cover relative"
              />
            
            </div>
            <span className="text-3xl font-bold bg-gradient-to-r from-white to-gray-200 bg-clip-text text-transparent">WeZen</span>
          </div>
          
          <p className="text-gray-300 mb-8 max-w-2xl mx-auto leading-relaxed">
            Votre compagnon quotidien pour un bien-être authentique et durable
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <Link
              to="/entreprise"
              className="group flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white px-6 py-3 rounded-full hover:bg-white/20 transition-all duration-300 border border-white/20"
              onClick={() => window.scrollTo(0, 0)}
            >
              <Star className="w-5 h-5 group-hover:scale-110 transition-transform" />
              Découvrir pour les entreprises
            </Link>
            <a
              href="#contact"
              className="group flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white px-6 py-3 rounded-full hover:bg-white/20 transition-all duration-300 border border-white/20"
            >
              <Heart className="w-5 h-5 group-hover:scale-110 transition-transform" />
              Nous contacter
            </a>
          </div>
          
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} WeZen. Tous droits réservés.
          </p>
        </div>
      </footer>
    </>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 via-white to-secondary-50">
      <Home />
    </div>
  );
}

export default App;